import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import Analytics from 'src/utils/Analytics'
import { ShippingContainer, ShippingOption, ShippingImageContainer, ShippingText } from './styles'
import { CURRENT_SEASONAL_STATE } from '../../utils/constants'

const ShippingDetails = ({
  frame,
  retail,
  setDisplayRetailPopup,
  size,
  inSeasonalState,
  automaticDiscount,
}) => {
  const { shipping, setup, returns, greenCheckmark, tag } = useStaticQuery(graphql`
    query ShippingIconsQuery {
      shipping: file(relativePath: { eq: "shipping.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      setup: file(relativePath: { eq: "setup.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      returns: file(relativePath: { eq: "returns.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      gift: file(relativePath: { eq: "gift.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      greenCheckmark: file(relativePath: { eq: "green-checkmark.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      tag: file(relativePath: { eq: "price-tag.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
    }
  `)

  const shippingText = 'Ships in 1-2 Business Days'

  const SHIPPING_INFO = [
    {
      image: setup,
      alt: 'clock',
      text: 'Easy Setup in 10 Minutes or Less',
    },
    {
      image: shipping,
      alt: 'speedy shipping truck',
      text: shippingText,
    },
    {
      image: returns,
      alt: 'Boxed return',
      text: '4-Month Free Returns',
    },
  ]

  if (inSeasonalState) {
    if (CURRENT_SEASONAL_STATE !== 'bfcmLastChance') {
      SHIPPING_INFO.unshift({
        image: greenCheckmark,
        alt: 'checkmark',
        text: `Arrives in time for Mother's Day`,
      })
    }
    if (automaticDiscount) {
      SHIPPING_INFO.unshift({
        image: tag,
        alt: 'pricetag',
        text: `Discount auto applied at checkout`,
      })
    }
  }
  return (
    <ShippingContainer frame={frame} id="shipping-details">
      {SHIPPING_INFO.map((option, i) => (
        <ShippingOption frame={frame} key={i}>
          <ShippingImageContainer truck={option.alt === 'speedy shipping truck'}>
            <GatsbyImage image={option.image.childImageSharp.gatsbyImageData} alt={option.alt} />
          </ShippingImageContainer>
          <ShippingText
            special={option.alt === 'checkmark' || option.alt === 'pricetag'}
            red={option.alt === 'present with bow'}
          >
            {option.text}{' '}
            {retail && option.alt === 'speedy shipping truck' && (
              <button
                type="button"
                onClick={() => {
                  setDisplayRetailPopup(true)
                  Analytics.track(
                    `Clicked ${
                      frame ? 'Frame' : `${size} Calendar`
                    } Need it Sooner Retail Popup CTA`
                  )
                }}
              >
                Need it sooner?
              </button>
            )}
          </ShippingText>
        </ShippingOption>
      ))}
    </ShippingContainer>
  )
}

export default ShippingDetails

ShippingDetails.propTypes = {
  frame: PropTypes.bool,
  retail: PropTypes.bool,
  setDisplayRetailPopup: PropTypes.func,
  size: PropTypes.number,
  inSeasonalState: PropTypes.bool,
  automaticDiscount: PropTypes.bool,
}
